import {Link} from "react-router-dom";

export default function MainBlockEquipment(props) {
    return (
        <section className="main_block main_block_equipment">
            <div className="container">
                <div className="bread_crumbs">
                    <div>
                        <Link to="/">Главная</Link>
                    </div>
                    <div>></div>
                    <div>Оборудование</div>
                </div>
                <h1>
                    <span className="title main_title">Оборудование</span>
                </h1>
            </div>
        </section>
    )
}
